import React, { useState } from 'react';
import { Empty, ErrorText, useChrome } from './ceoChrome';

export default function GrowthFunnelPanel({ colors, narrow, data, error }) {
  const chrome = useChrome(colors, narrow);
  const [days, setDays] = useState(30);
  const windows = (data && data.windows) || [];
  const current = windows.find((window) => window.days === days) || windows[0];

  return (
    <div style={chrome.page} data-testid="ceo-funnel">
      <div>
        <h2 style={chrome.title}>Growth funnel</h2>
        <p style={chrome.sub}>Signup cohort. Each percent is the share of the previous step.</p>
      </div>
      {error ? <ErrorText>{error}</ErrorText> : null}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }} role="tablist" aria-label="Window">
        {[7, 30, 90].map((value) => (
          <button
            key={value}
            type="button"
            onClick={() => setDays(value)}
            style={{ ...chrome.quiet, background: days === value ? '#1d1d1f' : chrome.surface, color: days === value ? '#fff' : chrome.text }}
          >
            {value} days
          </button>
        ))}
      </div>
      {!current && !error ? <Empty chrome={chrome}>Loading…</Empty> : null}
      {current ? (
        <div style={{ display: 'flex', flexDirection: narrow ? 'column' : 'row', gap: 12, alignItems: narrow ? 'stretch' : 'stretch' }}>
          {current.steps.map((step, index) => (
            <div key={step.id} style={{ ...chrome.panel, flex: 1 }} data-testid="funnel-step">
              <div style={{ color: chrome.secondary, fontSize: 13 }}>{index + 1}</div>
              <div style={{ fontSize: 17, fontWeight: 600, marginTop: 4 }}>{step.label}</div>
              <div style={{ fontSize: 32, fontWeight: 600, letterSpacing: '-0.03em', marginTop: 8 }}>{step.count}</div>
              <div style={{ color: chrome.secondary, fontSize: 14, marginTop: 4 }}>
                {step.conversion == null ? 'Start' : `${step.conversion}% of previous`}
              </div>
              {step.source ? <div style={{ color: chrome.muted, fontSize: 13, marginTop: 6 }}>{step.source}</div> : null}
            </div>
          ))}
        </div>
      ) : null}
      {data && data.websiteVisitsIncluded === false ? (
        <Empty chrome={chrome}>Website visits are omitted. No visit source is connected.</Empty>
      ) : null}
    </div>
  );
}
